export const SET_DATA_FIELD = 'SET_DATA_FIELD';
export const SET_TITLE_FIELD = 'SET_TITLE_FIELD';
export const SET_SETTING = 'SET_SETTING';
export const SET_COLOR = 'SET_COLOR';
export const SET_UUID = 'SET_UUID';
export const SET_RESUME = 'SET_RESUME';
export const RESET_RESUME = 'RESET_RESUME';
export const DOWNLOAD_RESUME = 'DOWNLOAD_RESUME';
export const TOGGLE_SECTION = 'TOGGLE_SECTION';
export const LOAD_RESUME = 'LOAD_RESUME';
export const EDITOR_LOADED = 'EDITOR_LOADED';

export const SET_SECTION_HEIGHT = 'SET_SECTION_HEIGHT';
export const ADD_SECTION_ITEM = 'ADD_SECTION_ITEM';
export const ADD_SECTION_ITEM_AFTER = 'ADD_SECTION_ITEM_AFTER';
export const CHANGE_SECTION_DATA = 'CHANGE_SECTION_DATA';
export const CHANGE_SECTION_TITLE = 'CHANGE_SECTION_TITLE';
export const CHANGE_SECTION_TITLES = 'CHANGE_SECTION_TITLES';

export const MOVE_ITEM = 'MOVE_ITEM';
export const DELETE_ITEM = 'DELETE_ITEM';
export const SET_ITEM_HEIGHT = 'SET_ITEM_HEIGHT';
export const CHANGE_ITEM_DATA = 'CHANGE_ITEM_DATA';

export const CONTACT_US_SENDING = 'CONTACT_US_SENDING';
export const CONTACT_US_CHANGE_DATA = 'CONTACT_US_CHANGE_DATA';
export const CONTACT_US_ERROR = 'CONTACT_US_ERROR';
export const CONTACT_US_FLUSH_ERRORS = 'CONTACT_US_FLUSH_ERRORS';
export const CONTACT_US_RECAPTCHA_LOADED = 'CONTACT_US_RECAPTCHA_LOADED';
export const CONTACT_US_SUCCESS = 'CONTACT_US_SUCCESS';
export const CONTACT_US_SEND_ERROR = 'CONTACT_US_SEND_ERROR';

export const CHANGE_TEMPLATE = 'CHANGE_TEMPLATE';

export const ADMIN_LOGIN_SENDING = 'ADMIN_LOGIN_SENDING';
export const ADMIN_LOGIN_SUCCESS = 'ADMIN_LOGIN_SUCCESS';
export const ADMIN_LOGIN_FAILED = 'ADMIN_LOGIN_FAILED';
export const ADMIN_UNAUTHORIZED = 'ADMIN_UNAUTHORIZED';

export const ADMIN_LIST_LOADING = 'ADMIN_LIST_LOADING';
export const ADMIN_LIST_LOADED = 'ADMIN_LIST_LOADED';
export const ADMIN_LIST_FINISHED = 'ADMIN_LIST_FINISHED';

export const GET_RESUMES_LIST = '[@@Admin] GET_RESUMES_LIST';
export const GET_RESUMES_LIST_SUCCESS = '[@@Admin] GET_RESUMES_LIST_SUCCESS';
export const GET_RESUMES_LIST_FAIL = '[@@Admin] GET_RESUMES_LIST_FAIL';
export const SET_PAGINATION_VALUES = '[@@Admin] SET_PAGINATION_VALUES';

export const ADMIN_VIEW_LOADING = 'ADMIN_VIEW_LOADING';
export const ADMIN_VIEW_LOADED = 'ADMIN_VIEW_LOADED';

export const TOOLBAR_DOWNLOAD_LOADING = 'TOOLBAR_DOWNLOAD_LOADING';
export const TOOLBAR_DOWNLOAD_FINISHED = 'TOOLBAR_DOWNLOAD_FINISHED';

export const AJAX_ERROR = '[@@Error] AJAX_ERROR';
export const CLEAR_AJAX_ERROR = '[@@Error] CLEAR_AJAX_ERROR';

export const USER_LOGIN_SENDING = 'USER_LOGIN_SENDING';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAILED = 'USER_LOGIN_FAILED';
export const USER_UNAUTHORIZED = 'USER_UNAUTHORIZED';

export const USER_ME_LOADING = 'USER_ME_LOADING';
export const USER_ME_LOADED = 'USER_ME_LOADED';
